import axios from 'axios';
import { REACT_APP_WORKING_URL } from '../Constants'
import { REACT_APP_WORKING_CHATAPI_URL } from '../Constants'


const sendResetPswdEmail = async (email)=>{
    const res = await axios.get(`${REACT_APP_WORKING_URL}users/sendResetPswdEmail/${email}`);
    return res.data;
}

const checkPasswordResetCode = async (email)=>{
    const res = await axios.post(`${REACT_APP_WORKING_URL}users/checkPasswordResetCode`, email);
    return res.data;
}

const setPassword = async (data)=>{
    const res = await axios.post(`${REACT_APP_WORKING_URL}users/setPassword`, data);
    return res.data;
}

export {
    sendResetPswdEmail, 
    checkPasswordResetCode,
    setPassword,
}